module.exports = __webpack_public_path__ + "static/media/banner10.64f78d89.jpg";